import CryptoJS from 'crypto-js';

const getJourneyEncryptionKey = () => {
  const key = import.meta.env.VITE_JOURNEY_QUERY_ENCRYPTION_KEY;
  return typeof key === 'string' && key.trim() ? key.trim() : null;
};

const encryptJourneyValue = (plainText) => {
  const key = getJourneyEncryptionKey();
  const value = String(plainText ?? "").trim();

  if (!value) return "";

  // If key is not configured, fall back to plain value
  // to avoid breaking existing flows.
  if (!key) return value;

  return CryptoJS.AES.encrypt(value, key).toString();
};

export const encryptJourneyQueryValue = (plainText) =>
  encryptJourneyValue(plainText);

export const encryptJourneySensitiveValue = (plainText) =>
  encryptJourneyValue(plainText);

export const decryptJourneyQueryValue = (cipherText) => {
  const key = getJourneyEncryptionKey();
  const value = String(cipherText ?? '').trim();
  if (!value) return '';
  if (!key) return value;

  try {
    const bytes = CryptoJS.AES.decrypt(value, key);
    const plain = bytes.toString(CryptoJS.enc.Utf8);
    return plain || '';
  } catch {
    return '';
  }
};

